export default "__VITE_ASSET__Dq25LHMh__"